import { render } from "./CRMWhatsappProductFollowupDialog.vue?vue&type=template&id=0f874297&scoped=true"
import script from "./CRMWhatsappProductFollowupDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappProductFollowupDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappProductFollowupDialog.vue?vue&type=style&index=0&id=0f874297&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f874297"]])

export default __exports__